var render, staticRenderFns
import script from "./NormalCell.vue?vue&type=script&lang=js"
export * from "./NormalCell.vue?vue&type=script&lang=js"
import style0 from "./NormalCell.vue?vue&type=style&index=0&id=0b491dd8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b491dd8",
  null
  
)

export default component.exports